var exports = {
  "k": "container__kYmfXz",
};

module.exports = exports;
